import { IconType, TableProps } from '@aibees/shared/components';
export interface EnrichButtonProps {
  className?: string;
  disabled?: boolean;
  table?: TableProps;
  isSmall?: boolean;
}

export interface MenuItem {
  label: string;
  icon?: IconType;
  dialogType?: EnrichButtonDialogType;
  helperText?: string;
}

export enum EnrichButtonDialogType {
  ReVerifyEmail = 'ReVerifyEmail',
  EnrichEmail = 'EnrichEmail',
  UpdateJobChange = 'UpdateJobChange',
  EnrichPhoneNumber = 'EnrichPhoneNumber',
  UpdateProfileInsights = 'UpdateProfileInsights',
  EnrichProfileInsights = 'EnrichProfileInsights',
}
